function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { forwardRef, useContext, memo } from 'react';
import styled, { css } from 'styled-components';
import getCoinbaseLocalizedUrl from '../../../utils/getCoinbaseLocalizedUrl.js';
import '../../Link/index.js';
import GlobalNavContext from '../context/GlobalNavContext.js';
import { jsx } from 'react/jsx-runtime';
import Link from '../../Link/Link.js';
const NavLinkItem = /*#__PURE__*/forwardRef(({
  navLink,
  activeTab,
  onMouseEnter,
  onClick,
  children,
  title,
  testID,
  onKeyDown,
  isButton
}, ref) => {
  let ariaControls = {};
  const _useContext = useContext(GlobalNavContext),
    localeCode = _useContext.localeCode;
  // Dont add aria controls for explore/prices nav item.
  if (navLink.key !== 'prices') {
    ariaControls = {
      'aria-expanded': activeTab?.toLocaleLowerCase() === navLink.key.toLocaleLowerCase(),
      'aria-controls': `global-nav-dropdown-${title?.toLowerCase()}`,
      role: 'button'
    };
  }
  const localizedUrl = navLink.url ? getCoinbaseLocalizedUrl(navLink.url, localeCode) : null;
  if (localizedUrl) {
    return /*#__PURE__*/jsx(StyledLink, {
      to: localizedUrl,
      ref: ref,
      title: title,
      testID: testID,
      onKeyDown: onKeyDown,
      ariaControls: ariaControls,
      children: /*#__PURE__*/jsx(LinkItemWrapper, {
        onMouseEnter: onMouseEnter,
        onClick: onClick,
        $isActive: activeTab === navLink.key,
        children: children
      })
    });
  }
  return /*#__PURE__*/jsx(ItemWrapper, _objectSpread(_objectSpread({
    onMouseEnter: onMouseEnter,
    onKeyDown: onKeyDown,
    tabIndex: 0,
    ref: ref,
    onClick: onClick,
    $isActive: activeTab === navLink.key,
    "data-testid": testID
  }, ariaControls), {}, {
    role: isButton ? 'button' : undefined,
    children: children
  }));
});
const NavLinkItem$1 = /*#__PURE__*/memo(NavLinkItem);
const ItemWrapper = styled.div`
  margin: 0 16px;
  display: inline-flex;
  align-items: center;
  cursor: default;
  box-shadow: none;
  position: relative;
  ${({
  $isActive,
  theme
}) => {
  /* using before pseudo / calculated values here
  in order to have the highlight line appear above the nav bottom border */
  return $isActive ? css`
          &:before {
            position: absolute;
            top: calc(100% - 3px);
            width: 100%;
            height: 4px;
            background: ${theme.color.textAccent};
            display: inline-block;
            content: '';
          }
        ` : '';
}};
`;
const LinkItemWrapper = styled(ItemWrapper)`
  cursor: pointer;
`;
const StyledLink = styled(Link)`
  line-height: 15px;
  display: inline-flex;
`;
export { NavLinkItem$1 as default };
//# sourceMappingURL=NavLinkItem.js.map
